import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  dateInfo: {
    color: '#979598',
    fontFamily: 'FiraSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '20px',
  },
  divider: {
    border: '1px solid #E8E8E8',
    marginBottom: '15px !important',
    marginTop: '31px !important',
  },
  formLabelClass: {
    color: '#241A2E',
    fontFamily: 'FiraSans-Regular',
    fontSize: '0.75rem',
    lineHeight: '24px',
    whiteSpace: 'nowrap',
  },
  gridheadingFlex: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  optionsClassName: {
    backgroundColor: theme.palette.common.white + '!important',
    paddingLeft: '10px !important',
    paddingRight: '27px !important',
    textTransform: 'capitalize',
  },
  renewalFormCardDivider: {
    margin: '12px 0px !important',
  },
  selectClassName: {
    backgroundColor: '#f3f3f3 !important',
    borderRadius: '7px !important',
    color: '#241A2E !important',
    fontFamily: 'FiraSans-Medium !important',
    fontSize: '0.875rem !important',
    fontWeight: ' 500 !important',
    letterSpacing: '0 !important',
    // opacity: '0.43 !important',
  },
  uploadDoc: {
    '& span': {
      marginLeft: '3px',
    },
    alignItems: 'end',
    color: '#0061FF !important',
    cursor: 'pointer !important',
    display: 'flex',
    fontFamily: 'FiraSans-SemiBold !important',
    fontSize: '0.875rem !important',
    fontWeight: '600 !important',
    textDecoration: 'underLine',
  },
}));

export default useStyles;
